export enum BonusRewardTypesQueryKeys {
  Statistics = 'bonus-reward-types/statistics',
  Aggregators = 'bonus-reward-types/aggregators',
}
